module.exports = __webpack_public_path__ + "img/10380999_767535726622217_3874985203538227003_n.9c765b82.jpg";